import { gql } from '@apollo/client';


export const GET_UNAUTHORIZED_ATTACHMENT_URL = gql`
  query GET_UNAUTHORIZED_ATTACHMENT_URL($id: ID!, $originatorId: ID!, $incidentId: ID) {
    getUnauthorizedAttachmentUrl(id: $id, originatorId: $originatorId, incidentId: $incidentId) {
      error
      redirectUrl
  }
}
`;
